<div
  class="d-flex align-items-center back-button"
  style="cursor: pointer"
  (click)="location.back()"
>
  <i class="fas fa-chevron-left fa-lg my-cursor"></i>
  <h5 class="my-0">{{ 'global.back' | translate | titlecase }}</h5>
</div>
